<template>
  <div class="row">
    <div class="col-lg-2">
      <img class="img"
           style="position:relative; left:-40px; width:150%; max-width:200px;"
           src="../../assets/img/aus_coloured.png"/>
    </div>
    <div class="col-lg-10">
      <div>
        <table class="table table-hover table-striped  table-responsive-md">
          <thead>
            <tr>
              <th>State</th>
              <th>Appr.</th>
              <th>Green</th>
              <th>Silver</th>
              <th>Gold</th>
              <th>Plat.</th>
              <th>Total</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="!loaded">
              <td>Loading data..</td>
            </tr>
            <tr v-if="loaded" v-for="(state, index) in states" :key="index">
              <td>{{ state[0] }}</td>
              <td>{{ state[1] }}</td>
              <td>{{ state[2] }}</td>
              <td>{{ state[3] }}</td>
              <td>{{ state[4] }}</td>
              <td>{{ state[5] }}</td>
              <td>{{ state[6] }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StateEnrolments',
  data () {
    return {
      loaded: false,
      states: []
    };
  },
  methods: {
    loadStates () {
      {
        this.axios.get('/statistics/states').then((rsp) => {
          let states = {};
          const statesRef = {
            1: 'ACT',
            2: 'NSW',
            3: 'NT',
            4: 'QLD',
            5: 'SA',
            6: 'TAS',
            7: 'VIC',
            8: 'WA'
          };
          for (let key of Object.keys(rsp.data)) {
            for (let stateKey of Object.keys(rsp.data[key].states)) {
              if (!Array.isArray(states[stateKey]))
                states[stateKey] = [statesRef[stateKey]]; // init array if not exists
              states[stateKey].push(rsp.data[key].states[stateKey]);
            }
          }
          // add totals
          for (let stateKey of Object.keys(states)) {
            const total = states[stateKey].reduce((sum, role) => {
              if (typeof role === 'number') sum += role;
              return sum;
            }, 0);
            states[stateKey].push(total);
          }
          this.states = states;
          this.loaded = true;
        }).catch((err) => this.$snotify.error(err.response.data.message, 'State Enrolments'));
      }
    }
  },
  mounted () {
    this.loadStates()
  }
};
</script>

<style scoped>

</style>